/* eslint-disable */
// jshint ignore: start
import { baseUrl } from '@/config';
import store from '@/store';
import merge from 'lodash/merge';
import min from 'lodash/min';
import MapConst from '@/constants/topologymap';
import { convertValuByUnit } from '@/utils/number';
import { Q, MapInfo, MapUtil } from '@/views/topologymap/js/maps';
import { isEmpty } from '@/utils/basic';

(function(Q) {
  function WidgetUI(node) {
    var model = node.get('model');
    var showResource = store.state.topologymap.viewMode == MapConst.VIEW_MODE.MONITORING ? (localStorage.getItem('map.filter.rsc') == 'SHOW' || (model.showRscFlag == '1' && localStorage.getItem('map.filter.rsc') == 'DEFAULT')) : model.showRscFlag == '1';

    removeAll(node);

    if ((!model.customimageId || model.customimageId < 1)) {
      if (model && model.styleOptions && model.styleOptions.imageType == 'widget') {
        makeFrame(node, showResource);
        makeIcon(node);
        makeName(node);
        makeIpaddress(node);

        if (showResource) {
          ['value1', 'value2'].forEach(function(type) {
            makeResourceLabel(node, type);
            makeBarUI(node, type);
          });
        }

        // 사이즈 고정
        node.size = {
          width: 200,
          height: showResource ? 94 : 52,
        };

        // 사이즈 변경 못하게
        node.resizable = false;

        // 이벤트 색상 변경 안하게
        node.setStyle(Q.Styles.RENDER_COLOR, null);

        // 범례 사이즈 고정
        var size = 73;
        if (node.eventCountLabelUI) {
          node.eventCountLabelUI.fontSize = size * (12 / 46);
          node.eventCountLabelUI.size = {
            width: size * (16 / 46),
            height: size * (16 / 46),
          }
          node.eventCountLabelUI.offsetX = size * (3 / 46);
          node.eventCountLabelUI.offsetY = -size * (3 / 46);
          node.eventCountLabelUI.border = size / 35;
        }
        if (node.activeUI) {
          node.activeUI.offsetX = -(size * (3 / 46));
          node.activeUI.offsetY = -(size * (3 / 46));
          node.activeUI.size = {
            width: size * (18 / 46),
            height: size * (18 / 46),
          }
        }
      }
    }
  }

  function removeAll(node) {
    var model = node.get('model');

    node.resizable = true;

    if (node.iconUI) {
      node.removeUI(node.iconUI);
      node.iconUI = null;
    }

    if (node.objNameUI) {
      node.removeUI(node.objNameUI);
      node.objNameUI = null;
    }

    if (node.ipaddressUI) {
      node.removeUI(node.ipaddressUI);
      node.ipaddressUI = null;
    }

    ['value1', 'value2'].forEach(function(type) {
      ['rsc', 'progress', 'dash', 'progresslabel', 'dashlabel'].forEach(function(ui) {
        var uiID = ui + type + 'UI';
        if (node[uiID]) {
          node.removeUI(node[uiID]);
          node[uiID] = null;
        }
      });
    });
  }

  function makeFrame(node, showResource) {
    var model = node.get('model');
    var eventColor = store.state.common.eventlevelInfo['NM'].eventlevelColorBg;

    if(node.eventStatus && model.objManagementApplyFlag == '1' && (localStorage.getItem('map.filter.event') == 'SHOW' || localStorage.getItem('map.filter.event') == 'DEFAULT')) {
      eventColor = node.eventStatus.eventlevelColorBg;
    }

    var frameUI = new Q.BaseUI();
    if (showResource) {
      frameUI.draw = function(ctx, scale, selected) {
        ctx.save();
        ctx.strokeStyle="rgba(0,0,0,0)";
        ctx.miterLimit=4;
        ctx.font="normal normal 400 normal 15px / 21.4286px ''";
        ctx.font="   15px ";
        ctx.scale(0.3970223325062035,0.3970223325062035);
        ctx.save();
        ctx.font="   15px ";
        ctx.save();
        ctx.font="   15px ";
        ctx.save();
        ctx.fillStyle="#FFFFFF";
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(201.333,85.25);
        ctx.bezierCurveTo(201.333,87.459,199.542,89.25,197.333,89.25);
        ctx.lineTo(6.332999999999998,89.25);
        ctx.bezierCurveTo(4.123999999999999,89.25,2.3329999999999984,87.459,2.3329999999999984,85.25);
        ctx.lineTo(2.3329999999999984,5);
        ctx.bezierCurveTo(2.3329999999999984,2.791,4.123999999999999,1,6.332999999999998,1);
        ctx.lineTo(197.333,1);
        ctx.bezierCurveTo(199.542,1,201.333,2.791,201.333,5);
        ctx.lineTo(201.333,85.25);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.save();
        ctx.fillStyle="#F2F2F5";
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(0.883,53.25);
        ctx.lineTo(0.883,91.25);
        ctx.bezierCurveTo(0.883,93.459,2.674,95.25,4.883,95.25);
        ctx.lineTo(196.883,95.25);
        ctx.bezierCurveTo(199.092,95.25,200.883,93.459,200.883,91.25);
        ctx.lineTo(200.883,53.25);
        ctx.lineTo(0.883,53.25);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.restore();
        ctx.save();
        ctx.font="   15px ";
        ctx.save();
        ctx.fillStyle="rgba(0,0,0,0)";
        ctx.strokeStyle = eventColor;
        ctx.lineWidth=1.5;
        ctx.miterLimit="10";
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(200.883,91);
        ctx.bezierCurveTo(200.883,93.209,199.09300000000002,95,196.883,95);
        ctx.lineTo(4.88300000000001,95);
        ctx.bezierCurveTo(2.6740000000000097,95,0.8830000000000098,93.209,0.8830000000000098,91);
        ctx.lineTo(0.8830000000000098,5);
        ctx.bezierCurveTo(0.8830000000000098,2.791,2.6740000000000097,1,4.88300000000001,1);
        ctx.lineTo(196.883,1);
        ctx.bezierCurveTo(199.09300000000002,1,200.883,2.791,200.883,5);
        ctx.lineTo(200.883,91);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.save();
        ctx.fillStyle = eventColor;
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(6.883,95);
        ctx.bezierCurveTo(6.883,96.657,5.54,95,3.883,95);
        ctx.lineTo(3.883,95);
        ctx.bezierCurveTo(2.226,95,0.883,93.657,0.883,92);
        ctx.lineTo(0.883,4);
        ctx.bezierCurveTo(0.883,2.343,2.226,1,3.883,1);
        ctx.lineTo(3.883,1);
        ctx.bezierCurveTo(5.54,1,6.883,-0.657,6.883,1);
        ctx.lineTo(6.883,95);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.restore();
        ctx.restore();
        ctx.restore();
      };
    } else {
      frameUI.draw = function(ctx, scale, selected) {
        ctx.save();
        ctx.strokeStyle="rgba(0,0,0,0)";
        ctx.miterLimit=4;
        ctx.font="normal normal 400 normal 15px / 21.4286px ''";
        ctx.font="   15px ";
        ctx.scale(0.3942498657086395,0.3942498657086395);
        ctx.save();
        ctx.fillStyle="#FFFFFF";
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(201.583,50.9);
        ctx.bezierCurveTo(201.583,52.448,200.314,53.704,198.748,53.704);
        ctx.lineTo(8.918,53.704);
        ctx.bezierCurveTo(7.353,53.704,6.084,52.448,6.084,50.9);
        ctx.lineTo(6.084,4.349);
        ctx.bezierCurveTo(6.084,2.801,7.353,1.5460000000000003,8.918,1.5460000000000003);
        ctx.lineTo(198.749,1.5460000000000003);
        ctx.bezierCurveTo(200.315,1.5460000000000003,201.584,2.801,201.584,4.349);
        ctx.lineTo(201.584,50.9);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.save();
        ctx.fillStyle=eventColor;
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(7.799,52.604);
        ctx.bezierCurveTo(7.799,54.248,6.456,52.604,4.799,52.604);
        ctx.lineTo(4.799,52.604);
        ctx.bezierCurveTo(3.1430000000000007,52.604,1.7990000000000004,51.274,1.7990000000000004,49.631);
        ctx.lineTo(1.7990000000000004,5.038);
        ctx.bezierCurveTo(1.7990000000000004,3.3960000000000004,3.1430000000000007,2.0650000000000004,4.799,2.0650000000000004);
        ctx.lineTo(4.799,2.0650000000000004);
        ctx.bezierCurveTo(6.456,2.0650000000000004,7.799,0.4230000000000005,7.799,2.0650000000000004);
        ctx.lineTo(7.799,52.604);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.save();
        ctx.fillStyle="rgba(0,0,0,0)";
        ctx.strokeStyle=eventColor;
        ctx.lineWidth=1.5;
        ctx.miterLimit="10";
        ctx.font="   15px ";
        ctx.beginPath();
        ctx.moveTo(201.798,49.334);
        ctx.bezierCurveTo(201.798,51.543000000000006,200.007,53.334,197.798,53.334);
        ctx.lineTo(5.798000000000002,53.334);
        ctx.bezierCurveTo(3.5890000000000017,53.334,1.7980000000000018,51.543000000000006,1.7980000000000018,49.334);
        ctx.lineTo(1.7980000000000018,5.334000000000003);
        ctx.bezierCurveTo(1.7980000000000018,3.125000000000003,3.5890000000000017,1.3340000000000032,5.798000000000002,1.3340000000000032);
        ctx.lineTo(197.798,1.3340000000000032);
        ctx.bezierCurveTo(200.007,1.3340000000000032,201.798,3.125000000000003,201.798,5.334000000000003);
        ctx.lineTo(201.798,49.334);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
        ctx.restore();
      }
    }
    node.image = frameUI;
  }

  function makeIcon(node) {
    var icon = new Q.ImageUI(Q.getImage(node));
    icon.size = {
      width: 36,
      height: 36
    };
    icon.syncSelection = true;
    icon.syncSelectionStyles = true;
    icon.position = Q.Position.RIGHT_TOP;
    icon.anchorPosition = Q.Position.RIGHT_TOP;
    icon.padding = new Q.Insets(8, 13);
    icon.width = 36 ;
    icon.height = 36;
    node.addUI(icon);
    node.iconUI = icon;
  }

  function makeName(node) {
    var model = node.get('model');
    var objName = model.objName || model.ipaddress || '';
    var name = objName.length > 8 ? objName.substr(0, 8) + '..' : objName;

    var label = new Q.LabelUI(name);
    label.color = "#555";
    label.fontFamily = "lato";
    label.fontSize = 14;
    label.fontStyle = "bold";
    label.syncSelection = false;
    label.position = Q.Position.LEFT_TOP;
    label.anchorPosition = Q.Position.LEFT_TOP;
    label.padding = new Q.Insets(11, 19);
    node.addUI(label);
    node.objNameUI = label;

    node.setStyle(Q.Styles.LABEL_VISIBLE, 0);
  }

  function makeIpaddress(node) {
    var model = node.get('model');

    var ip = new Q.LabelUI((model.ipaddress) ? model.ipaddress : '-');
    ip.color = "#999";
    ip.fontFamily = "lato";
    ip.fontSize = 11;
    ip.syncSelection = false;
    ip.position = Q.Position.LEFT_TOP;
    ip.anchorPosition = Q.Position.LEFT_TOP;
    ip.padding = new Q.Insets(28, 19);
    node.addUI(ip);
    node.ipaddressUI = ip;
  }

  function makeResourceLabel(node, type) {
    var uiID = 'rsc'+ type + 'UI';

    var rscLabel = new Q.LabelUI(node[type+'.'+'rsc'] || '-');
    rscLabel.color = "#555";
    rscLabel.fontFamily = "lato";
    rscLabel.fontSize = 12;
    rscLabel.syncSelection = false;
    rscLabel.zIndex = 1;
    rscLabel.position = (type === 'value1') ? {x: 15, y: 64} : {x: 15, y: 80};
    rscLabel.anchorPosition = Q.Position.LEFT_MIDDLE;
    node.addUI(rscLabel);
    node[uiID] = rscLabel;


    var key = type == 'value1' ? 'rsc1' : 'rsc2';
    if (node[key + 'NameUI']) {
      node[key + 'NameUI'].visible = false;
    }
    if (node[key + 'ValueUI']) {
      node[key + 'ValueUI'].visible = false;
    }
  }

  function makeBarUI(node, type) {
    var model = node.get('model');
    var uiType = (node[type+'.'+'unit'] == '%') ? 'progress' : 'dash';
    var barUiID = uiType + type + 'UI';
    var barLabelUiID = uiType + 'label' + type + 'UI';
    var data = node.rscValue ? node.rscValue[type] || 0 : 0;
    var label = node[type+'.'+'value'];
    var rscLabel = node[type+'.'+'rsc'] || '-';

    var bar = new Q.BaseUI();
    bar.width = 90;
    bar.height = 12;
    bar.data = (data == 0) ? -1 : data;
    bar.label = label;
    bar.offsetStart = rscLabel.length > 3 ? 10 : 0;
    bar.draw = function(g, scale, selected) {
      var data = this.data;

      if (uiType === 'progress') {
        // progressbar background
        g.beginPath();
        g.moveTo(this.offsetStart, 3);
        g.lineTo(90, 3);
        g.lineWidth = 6;
        g.lineCap = 'round';
        g.strokeStyle = '#e0e0e0';
        g.stroke();

        // progressbar
        if(data != -1) {
          var w = (data / 100) * this.width;
          g.beginPath();
          g.moveTo(this.offsetStart, 3);
          g.lineTo(w, 3);
          g.lineWidth = 6;
          g.lineCap = 'round';
          g.strokeStyle = '#d1c8de';
          g.stroke();
        }

      } else {
        // dashline
        g.lineWidth = 2;
        g.setLineDash([4, 3]);
        g.lineDashOffset = 5;
        g.beginPath();
        g.moveTo(-2, 3);
        g.lineTo(90, 3);
        g.strokeStyle = '#e0e0e0';
        g.stroke();
      }
    };


    bar.position = (type === 'value1') ? {x: 50, y: 60} : {x: 50, y: 76};
    node.addUI(bar);
    node[barUiID] = bar;

    var str = (label === '-') ? (label + node[type+'.'+'unit']) : label;
    var label = new Q.LabelUI(str);
    label.color = "#555";
    label.fontFamily = "lato";
    label.fontSize = 12;
    label.syncSelection = false;
    label.backgroundColor = "#F2F2F5"
    label.anchorPosition = Q.Position.RIGHT_TOP;
    label.position = (type === 'value1') ? {x: 195, y: 56} : {x: 195, y: 72};
    label.padding = new Q.Insets(0, 5);
    node.addUI(label);
    node[barLabelUiID] = label;
  }

  Q.WidgetUI = WidgetUI;
})(window.Q);
// jshint ignore:end
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/views/topologymap/js/widget.js